import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'headerItemTitle',
})
export class HeaderItemTitlePipe implements PipeTransform {
    public transform(value: string): unknown {
        return value
            .replace(/&nbsp;/g, '')
            .replace(' ', ' '); // catalogos usa ascii para dar un espacio desde gesticor.
    }
}
